import { awsApi, awsApiWithRetry } from '../../utils/apiAwsClient';
import { Image } from '../../types/image';
import { putImageProductMetaData } from './productoService';
import { UsoImagenType } from '../../types/image';
import { ImageAnalysis, BatchUpdateResponse, ProcessedImage } from '../../types/imageMetadata';


interface FileWithUsage {
    file: File;
    usoImagen: UsoImagenType;
} 

export const getProductImages = async (productCode: string): Promise<Image[]> =>{
    try {
        //const response = await awsApi.get(`/products/aws/${encodeURIComponent(productCode)}`);
        //return response.data.images || response.data || [];
        console.log(`Encoded product: ${encodeURIComponent(productCode)}` );
        const response = await awsApiWithRetry<Image[]>({
            method: 'GET',
            url:`/products/aws/${encodeURIComponent(productCode)}`,
            timeout: 15000, // 30 segundos
        });
        console.log('Respuesta retornada desde el api, en getProductImages en imageService:', response);
        return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
        console.error('Error fetching images:', error);
        throw error;
    }    
};

export const deleteProductImage = async (productCode: string): Promise<any> =>{
    console.log('productCode a borrar: ', productCode)
    const sku = productCode.includes('.') ? productCode.split('.')[0] : productCode;
    try {
        const response = await awsApi.delete(`/products/aws/delete/${encodeURIComponent(sku)}/${encodeURIComponent(productCode)}`);
        //console.log(`Respuesta retornada desde el api, en deleteProductImage en imageService: ${response}`);
        console.log('Respuesta retornada desde el api, en deleteProductImage en imageService:', response);
        return response;
    } catch (error) {
        console.error('Error borrando imagen: ', error);
        return false;
    }
};


export const testAWSConnection = async(): Promise<boolean> => {
    try {
        const response = await awsApi.get(`/productos/${encodeURIComponent('101003')}`);
        //Incluso si falla, porque la imagen no existe, significa que la conexión funciona
        return response.status !== 502 && response.status !== 503;
    } catch (error) {
        console.error('AWS Connection test failed:', error);
        return false;
    }
};

export const uploadProductImage = async (
    productCode: string, 
    files: FileWithUsage[],
    //usoImagen: string = 'GENERAL', 
    usuario: string): Promise<any[]> => {

    console.log('Entre a uploadProductImage: ',productCode);

    try {
        const uploadPromises = files.map(async (fileWithUsage) => {
            const formData = new FormData();
            formData.append('file', fileWithUsage.file);
            //Agregar Campos adicionales en el formData si es necesario
            formData.append('usoImagen', fileWithUsage.usoImagen);
            formData.append('tipoArchivo', fileWithUsage.file.type);
            formData.append('usuario', usuario);

            console.log('tipo archivo', fileWithUsage.file.type);
            
            const response = await awsApi.post(`/products/aws/upload/${encodeURIComponent(productCode)}`, formData, {
                headers: {
                    Authorization: 'Bearer '
                    //"Content-Type": "multipart/form-data",
                },
            });
            
            return response.data; 
        });

        return Promise.all(uploadPromises);  
    } catch (error) {
        console.error('Error subiendo imagen: ', error);
        throw error;
    }  
};


export const updateImageUsage = async (
    sku: string, 
    imageName: string, 
    usoImagen: string, 
    usuario: string
): Promise<any> => {
    try {
        // 1. Actualizar metadata en S3
        const s3Response = await awsApi.put(`/products/aws/update-metadata/${imageName}`, {
            sku,
            usoImagen,
            usuario,
            fechaActualizacion: new Date().toISOString()
        });

        // 2. Actualizar registro en Oracle
        const oracleResponse = await putImageProductMetaData(sku, {
            imageName,
            usoImagen,
            usuario
        });

        return {
            s3: s3Response.data,
            oracle: oracleResponse.data
        };
    } catch (error) {
        console.error('Error updating image usage:', error);
        throw error;
    }
};

export const getImageMetadata = async (imageName: string): Promise<any> => {
    try {
        const response = await awsApi.get(`/images/metadata/${imageName}`);
        return response.data;
    } catch (error) {
        console.error('Error getting image metadata:', error);
        throw error;
    }
};

// Nuevo método para obtener el análisis de imágenes 31/10/2025
export const getImageAnalysis = async (nextContinuationToken?: string, pageSize: number = 100 ): Promise<ImageAnalysis> => {
    try {

        const params: any = {
            action: 'analyze',
            pageSize: pageSize,
        };
        
        if (nextContinuationToken && nextContinuationToken !== "null" && nextContinuationToken !== "undefined") {
            params.continuationToken = encodeURIComponent(nextContinuationToken);
        }
        console.log("Enviando parámetros al API:", params);

        const response = await awsApi.get(`/products/aws/metadata/analyzeMetadata`, {
            params: params
        });
        console.log('Respuesta de getImageAnalysis:', response.data);
        return response.data;
    } catch (error: any) {
        console.error('Error getting image analysis:', error);
        throw error?.message || 'Error getting image analysis';
    }
};


/**
 * Actualiza en lote los metadatos de múltiples imágenes.
 */
export const updateImagesMetadata = async(
    imagesToUpdate: ProcessedImage[],
    defaultMetadata: Record<string, string> = {},
    oracleResults?: Record<string, { success: boolean; error?: string }>

): Promise<BatchUpdateResponse> => {
    try {
        const response = await awsApi.post<BatchUpdateResponse>(`/products/aws/metadata/update`, {
            imagesToUpdate, 
            defaultMetadata,
            oracleResults
        });
        console.log('Respuesta de updateImagesMetadata:', response.data);
        return response.data;

    } catch (error) {
        console.error('Error updating images metadata en service:', error);
        throw error;
    }
};
